type LoadingEvent = {
  isLoading: boolean;
  url?: string;
  method?: string;
};

type ApiEventListener = (event: LoadingEvent) => void;

class ApiEventEmitter {
  private listeners: ApiEventListener[] = [];

  addListener(listener: ApiEventListener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  emit(event: LoadingEvent) {
    this.listeners.forEach(listener => listener(event));
  }
}

export const apiEventEmitter = new ApiEventEmitter();
